import { E_INVOICE_STATUS_MAP, STATUS_MAP } from './constant';
import { formatDate } from '@/lib/formatUtils';
import { ExcelColumnMapping } from './types';

export const PHIEU_XUAT_TRA_LAI_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Trạng thái',
    width: 16,
    resolver: row => STATUS_MAP[row?.status] || row?.status || ''
  },
  {
    header: 'Trạng thái HĐĐT',
    width: 20,
    resolver: row => E_INVOICE_STATUS_MAP[row?.ma_tthddt] || row?.ma_tthddt || ''
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row?.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => formatDate(row?.ngay_ct)
  },
  {
    header: 'Mã khách hàng',
    width: 20,
    resolver: row => row?.ma_kh_data?.customer_code || row?.ma_kh || ''
  },
  {
    header: 'Tên khách hàng',
    width: 28,
    resolver: row => row?.ma_kh_data?.customer_name || row?.ten_kh || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row?.dien_giai || ''
  },
  {
    header: 'Tài khoản',
    width: 12,
    resolver: row => row?.tk_data?.code || row?.tk || ''
  },
  {
    header: 'Tổng tiền',
    width: 18,
    resolver: row => Number(row?.t_tt_nt || row?.t_tt || '')
  },
  {
    header: 'Ngoại tệ',
    width: 12,
    resolver: row => row?.ma_nt_data?.ma_nt || row?.ma_nt || ''
  }
];
